import * as React from 'react';
import * as classNames from 'classnames';
import { NavigationProps } from '../';
import { DesktopNavigationItem } from './DesktopNavigationItem';
import { NavigationRoot } from '../../../../models';
import './style.css';

export interface DesktopNavigationState {
  /* empty */
}

export class DesktopNavigation extends React.Component<
  NavigationProps,
  DesktopNavigationState
> {
  render() {
    const { expanded, items } = this.props;

    const navMenuItems = this.getMenuItems(items);

    const classes = classNames({
      expanded,
      'desktop-navigation': true
    });

    return (
      <nav className={classes}>
        <ul className="desktop-navigation-list">{navMenuItems}</ul>
      </nav>
    );
  }

  private getMenuItems = (items: Array<NavigationRoot>): Array<JSX.Element> => {
    const elements: Array<JSX.Element> = [];

    const { desktopExpandedItem, onExpandItem, onCollapseItem } = this.props;

    for (let index = 0; index < items.length; index++) {
      const item: NavigationRoot = items[index];

      elements.push(
        <DesktopNavigationItem
          key={item.name}
          item={item}
          desktopExpandedItem={desktopExpandedItem}
          onExpandItem={onExpandItem}
          onCollapseItem={onCollapseItem}
        />
      );
    }

    return elements;
  };
}

export default DesktopNavigation;



// WEBPACK FOOTER //
// ./src/app/components/App/Navigation/DesktopNavigation/index.tsx